import { Link, useLocation, useParams } from 'react-router-dom'
import { movieApi } from '../../redux/services/movieApi'
import './Movie.scss'
import { Rating } from '../../ui/Rating/Rating'
import noImg from '../../assets/img/no-img.webp'
import { Modal } from '../../ui/Modal/Modal'
import { useEffect, useMemo, useState } from 'react'
import ReactPlayer from 'react-player/youtube'
import { LoaderMoviePage } from '../../ui/LoaderMoviePage/LoaderMoviePage'
import svg from "../../assets/img/sprite.svg";
import { userApi } from '../../redux/services/userApi'
import { FormModal } from '../FormModal/FormModal'
import { favoritesApi } from '../../redux/services/favoritesApi'
import { convertToHours } from '../../utils/utils'

export const Movie = () => {

    /* Получение URL */
    const urlPathname = useLocation().pathname

    /* Cостояние модального окна Трейлер */
    const [modalActive, setModalActive] = useState(false);

    /* Cостояние модального окна Входа */
    const [logRegModal, setLogRegModal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);

    /* Состояние кнопки лайк */
    const [like, setLike] = useState(false);

    /* Добавление любимых фильмов */
    const [addFavorites] = favoritesApi.useAddFavoritesMutation()

    /* Получение рандомных фильмов */
    const { data: randomMovie, isLoading, error, refetch } = movieApi.useGetRandomMovieQuery(`/movie/random`)

    /* Получение фильма по id */
    const { movieId } = useParams()
    const id = Number(movieId)
    const { data: movie } = movieApi.useFetchIdMovieQuery(id)

    /* Генерируем необходимый массив */
    const dataToUseMovie = useMemo(() => (urlPathname !== '/' ? movie : randomMovie), [urlPathname, movie, randomMovie]);

    /* Получение профиля юзера и его любимых фильмов */
    const { data: userProfile } = userApi.useUserProfileQuery(`/profile`, {
        refetchOnMountOrArgChange: true,
    })

    /* Удаление фильма из любимых */
    const [delFavorites] = favoritesApi.useDelFavoritesMutation()

    const handleAddFavorite = async () => {
        if (userProfile === undefined) {
            setLogRegModal(!logRegModal)
        } else {
            await addFavorites({ id: String(dataToUseMovie && dataToUseMovie.id) })
            setLike(!like)
        }
    }

    const handleDelFavorite = async () => {
        await delFavorites(String(dataToUseMovie && dataToUseMovie.id))
        setLike(!like)
    }

    const handleRandomMovie = () => {
        refetch()
    }

    /* Проверка на наличие есть ли фильм в избранном у юзера */
    useEffect(() => {
        if (dataToUseMovie && userProfile) {
            const stringId = String(dataToUseMovie.id);
            setLike(userProfile.favorites && userProfile.favorites.includes(stringId) ? true : false);
        } else {
            setLike(false)
        }
    }, [dataToUseMovie, userProfile]);

    return (
        <section className='movie'>
            <div className="container">
                {isLoading && <LoaderMoviePage />}
                {error &&
                    <div>
                        <h2 style={{ marginBottom: "10px" }}> Произошла ошибка</h2> <button className='btn btn-dark' onClick={() => refetch()}>Обновить список</button>
                    </div>}
                {dataToUseMovie &&
                    <div className="movie__container">
                        <div className="movie__wrap">
                            <div className="movie__dscr">
                                <Rating rating={dataToUseMovie.tmdbRating} />
                                <span className='movie__year'>{dataToUseMovie.releaseYear}</span>
                                <span className='movie__genre'>{dataToUseMovie.genres[0]}</span>
                                <span className='movie__runtime'>{convertToHours(dataToUseMovie.runtime)}</span>
                            </div>
                            <h1 className='movie__title'>{dataToUseMovie.title}</h1>
                            <p className='movie__plot'>{dataToUseMovie.plot}</p>
                            <div className="movie__btn">
                                <button style={urlPathname === '/' ? { width: '100%' } : { width: 'auto' }} onClick={() => setModalActive(!modalActive)} className='btn btn-blue'>Трейлер</button>
                                <Link style={urlPathname === '/' ? { display: 'flex' } : { display: 'none' }} className='btn btn-dark movie__btn-movie' to={`/movie/${dataToUseMovie.id}`} key={dataToUseMovie.id}>
                                    О фильме
                                </Link>
                                <button style={like ? { display: 'none' } : { display: 'block' }} onClick={handleAddFavorite} className='btn btn-dark btn-mini'>
                                    <svg className="btn__like" width="24" height="24">
                                        <use xlinkHref={`${svg}#like`}></use>
                                    </svg>
                                </button>
                                <button style={like ? { display: 'block' } : { display: 'none' }} onClick={handleDelFavorite} className='btn btn-dark btn-mini'>
                                    <svg className="btn__like-add" width="24" height="24">
                                        <use xlinkHref={`${svg}#like`}></use>
                                    </svg>
                                </button>
                                <button style={urlPathname === '/' ? { display: 'block' } : { display: 'none' }} className='btn btn-dark btn-mini' onClick={handleRandomMovie}>
                                    <svg className="btn__random" width="24" height="24">
                                        <use xlinkHref={`${svg}#random`}></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="movie__backdrop">
                            <img className='movie__backdrop-img' src={dataToUseMovie.backdropUrl !== null ? dataToUseMovie.backdropUrl : noImg} alt={dataToUseMovie.title} />
                        </div>
                        <Modal active={modalActive} setActive={setModalActive}>
                            <div style={{ minWidth: '70vw' }}>
                                <ReactPlayer playing={modalActive} controls={true} muted={true} width='100%' height='70vh' url={dataToUseMovie.trailerUrl} />
                            </div>

                        </Modal>
                        <FormModal logRegModal={logRegModal} setLogRegModal={setLogRegModal} successModal={successModal} setSuccessModal={setSuccessModal} />
                    </div>
                }
            </div>
        </section>

    )
}